<template>

  <v-container fluid class="page page-order-list">

    <!-- Breadcrumb -->
    <v-row class="mt-4 mb-8">
      <v-col cols="12" class="d-flex align-center justify-start page-breadcrumb-new">
        <v-icon small class="mr-2">mdi-package-variant-closed</v-icon>
        <div>Orders</div>
      </v-col>
    </v-row>

    <order-shipper-message-notifications
        class="mb-6"
        :notifications="notifications" />

    <!-- Page Navigation -->
    <v-tabs fixed-tabs show-arrows class="page-navigation" v-model="activeTab">
      <v-tab @click="$root.goTo('order-list-placed')">Ready to Schedule</v-tab>
      <v-tab @click="$root.goTo('order-list-being-scheduled')">Being Scheduled</v-tab>
      <v-tab @click="$root.goTo('order-list-scheduled')">Dispatched</v-tab>
      <v-tab @click="$root.goTo('order-list-on-delivery')">On Delivery</v-tab>
      <v-tab @click="$root.goTo('order-list-delivered')">Delivered</v-tab>
      <v-tab @click="$root.goTo('order-list-canceled')">Canceled</v-tab>
    </v-tabs>

    <!-- Page Content -->
    <v-container fluid class="px-0">
      <transition name="fade-flash" mode="out-in">
        <router-view />
      </transition>
    </v-container>

  </v-container>

</template>

<script>
import OrderShipperMessageNotifications from '@/components/orderMessages/OrderShipperMessageNotifications'

export default {
  name: 'OrderListRootPage',

  components: {
    OrderShipperMessageNotifications
  },

  data () {
    return {
      activeTab: 0, // order-list-placed
      notifications: null
    }
  },

  async beforeMount () {
    // Set active tab
    switch (this.$route.name) {
      case 'order-list-placed': this.activeTab = 0; break
      case 'order-list-being-scheduled': this.activeTab = 1; break
      case 'order-list-scheduled': this.activeTab = 2; break
      case 'order-list-on-delivery': this.activeTab = 3; break
      case 'order-list-delivered': this.activeTab = 4; break
      case 'order-list-canceled': this.activeTab = 5; break
    }

    await this.loadNotifications()
  },

  methods: {
    async loadNotifications () {
      try {
        const newMessages = await this.$store.dispatch('sh/dataApi', {
          method: 'get',
          uri: 'order-shipper-messages',
          opts: {
            params: {
              is_confirmed: false,
              with: 'order.shipper,order.receiver'
            }
          }
        })

        this.notifications = newMessages.items
      } catch (err) {
        // this.dataLoadingError = err.message || err.text || err
      }
    }
  }
}
</script>

<style>
</style>
